var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _circle, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClipboardCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 83,
    viewBox: "0 0 75 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.9949 9.91016H3.91251C1.75169 9.91016 0 11.5627 0 13.6012V76.3805C0 78.419 1.75169 80.0716 3.91251 80.0716H52.9949C55.1558 80.0716 56.9074 78.419 56.9074 76.3805V13.6012C56.9074 11.5627 55.1558 9.91016 52.9949 9.91016Z",
    fill: "#0064E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 13.0768H28.6727H40.1029H45.1717L51.533 13.0586V19.901V20.6385L51.719 73.5703H5.8125V13.0768Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4272 15.9011H40.6379C41.0097 15.9011 41.3663 15.7534 41.6292 15.4904C41.8921 15.2275 42.0398 14.871 42.0398 14.4992V10.3916C42.042 9.97782 41.9459 9.56941 41.7594 9.19999C41.4976 8.60483 41.0864 8.08747 40.5656 7.69813C40.0449 7.3088 39.4323 7.06074 38.7874 6.978C36.3762 6.78874 35.3878 7.51772 33.0607 4.08308C32.6057 3.39942 32.0062 2.82403 31.3044 2.39756C30.6027 1.97109 29.8158 1.70393 28.9994 1.61501C28.1831 1.52608 27.3572 1.61755 26.5801 1.88293C25.803 2.14831 25.0936 2.58115 24.5021 3.15083C22.6446 5.09947 23.4998 6.93593 20.0512 6.90088C17.1983 6.90088 15.3338 7.20931 15.0954 10.5038C14.999 11.8473 14.9756 13.1951 15.0254 14.5412C15.0363 14.9057 15.1888 15.2515 15.4505 15.5054C15.7123 15.7593 16.0626 15.9012 16.4272 15.9011Z",
    fill: "#0064E0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.3984,
    y: 21.5898,
    width: 32.7336,
    height: 7.16199,
    rx: 0.797015,
    fill: "#D7DFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3984,
    y: 35.9153,
    width: 14.2376,
    height: 3.0053,
    rx: 1.50265,
    fill: "#D7DFFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3984,
    y: 43.7239,
    width: 31.6452,
    height: 3.0053,
    rx: 1.50265,
    fill: "#D7DFFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.3984,
    y: 49.6575,
    width: 31.6452,
    height: 3.0053,
    rx: 1.50265,
    fill: "#D7DFFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54.8193,
    cy: 62.8672,
    r: 18.2061,
    fill: "#FF2727",
    stroke: "#FFE7E7",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8947 62.8698L59.9799 66.955V68.0316H58.9033L54.8181 63.9464L50.7329 68.0316H49.6562V66.955L53.7415 62.8698L49.6562 58.7846V57.708H50.7329L54.8181 61.7932L58.9033 57.708H59.9799V58.7846L55.8947 62.8698Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCross);
export default __webpack_public_path__ + "static/media/clipboard-cross.84b9acdbb0c50876c9452bb414fe7561.svg";
export { ForwardRef as ReactComponent };